/**
 * Created by Andrey Popov on 16.08.2022
 */

const Feedable = function (unit) { 
    UnitComponent.call(this, unit);

    const data = this.unit.getData().feedable;

    this.food = data.food;
    this.useFoodIcon = data.useFoodIcon;
    this.canStarve = data.canStarve;

    this.eating = false;
    this.setupPrize();
};

Feedable.prototype = Object.create(UnitComponent.prototype);
Feedable.prototype.constructor = Feedable;

Feedable.prototype.onInfoClosed = function (withAction) {
    if (!withAction && this.isHungry()) {
        this.unit.setPrizes();
        this.onUpdateFeedIcon(true);
    }
};

Feedable.prototype.getImageForFood = function () {
    return this.useFoodIcon ? UnitView.UnitIconFrame(this.food) : cleverapps.skins.getSlot("feed_icon_png");
};

Feedable.prototype.acceptDraggable = function (unit) {
    this.feed();

    const feedable = this.unit.findComponent(Feedable);
    Map2d.currentMap.showLayerTile(Map2d.LAYER_UNITS, this.unit.x, this.unit.y);
    unit.findComponent(Collectible).onFeed(this.unit.onGetView(), () => {
        feedable.onFeed();
    });
    unit.remove(true);
};

Feedable.prototype.onFeed = function () {
    if (this.view) {
        this.view.feed();
    }
};

Feedable.prototype.handlePrizes = function () {
    if (this.state === Feedable.STATE_STARVE) {
        const foodSource = UnitLocator.getFoodSource(this);

        if (foodSource) {
            Map2d.currentMap.focusOnUnit(foodSource, {
                allowScrollWithFocus: true
            });

            Map2d.currentMap.showLayerTile(Map2d.LAYER_UNITS, foodSource.x, foodSource.y);
            FingerView.hintTap(foodSource, {
                runOnce: true
            });

            cleverapps.centerHint.create({
                food: this.food,
                unit: foodSource
            });
        }
        return true;
    }
};

Feedable.prototype.setupPrize = function () {
    const prize = this.unit.getData().prize;
    const resource = prize.resource;
    const amount = prize.amount;

    this.prize = {
        resource,
        amount
    };
};

Feedable.prototype.feed = function () {
    this.eating = true;
    this.state = Feedable.STATE_FULL;
    this.unit.setPrizes();
    this.onUpdateFeedIcon(false);

    this.feedTime = Date.now();

    const game = Map2dLocation.currentLocation;

    const reward = this.prize.resource;
    let rewardAmount = this.prize.amount;
    if (reward === "pawsPoints" && (Map2dLocation.currentLocation.tutorial.checkConditions({ advice: [Map2d.FEED_HERO] }) || cleverapps.tutorial.checkConditions({ advice: [Map2d.FEED_HERO] }))) {
        rewardAmount = Map2dLocation.currentLocation.pawBox.getPointsLeft();
    }

    game.counter.setTimeout(() => {
        this.eating = false;
        Map2dLocation.currentLocation.addReward(reward, rewardAmount, this.unit, { withoutDelta: true });
        Map2d.mapEvent(Map2d.FEED_HERO, { affected: this.unit });
        cleverapps.tutorial.trigger(Map2d.FEED_HERO);

        cleverapps.effects.fire("merge.feed");
        Feedable.processFeedable();
    }, Feedable.FOOD_FLY_TIME);
};

Feedable.prototype.isAcceptable = function (unit) {
    return Unit.IsApplicable(this.food, unit);
};

Feedable.prototype.canCollect = function (unit) {
    return this.isHungry() && this.isAcceptable(unit);
};

Feedable.prototype.canAcceptDraggable = function (unit) {
    return this.isHungry() && Unit.IsApplicable(this.food, unit);
};

Feedable.prototype.isReady = function () {
    return this.getTimeLeft() <= 0;
};

Feedable.prototype.isHungry = function () {
    return this.state === Feedable.STATE_HUNGRY;
};

Feedable.prototype.getTimeLeft = function () {
    const feedTime = this.feedTime || 0;
    return Math.max(0, feedTime + Feedable.FEED_COOLDOWN - Date.now());
};

Feedable.prototype.getActionInfo = function () {
    const foods = Map2d.currentMap.listAvailableUnits(this.food);
    if (this.isHungry() && foods.length > 0) {
        return {
            feedableInfoView: true,
            food: foods[0]
        };
    }
};

Feedable.prototype.clearTimer = function () {
    if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = undefined;
    }
};

Feedable.prototype.updateTimer = function () {
    this.clearTimer();

    this.timeout = new cleverapps.LongTimeout((() => {
        Feedable.processFeedable();
    }), this.getTimeLeft());
};

Feedable.prototype.setState = function (state) {
    if (this.state === state) {
        return;
    }

    this.state = state;

    this.clearTimer();

    if (this.state === Feedable.STATE_HUNGRY) {
        this.unit.setPrizes();
        this.onUpdateFeedIcon(true);
    } else if (this.state === Feedable.STATE_FULL) {
        this.unit.setPrizes();
        this.onUpdateFeedIcon(false);
    } else if (this.state === Feedable.STATE_STARVE && cleverapps.meta.selectedLocationId() !== "collections") {
        this.unit.setPrizes({ sprite: bundles.merge.frames.prize_exclamation_off });
        this.onUpdateFeedIcon(false);
    }
};

Feedable.prototype.onInfoOpened = function () {
    this.onUpdateFeedIcon(false);
};

Feedable.prototype.onUpdateFeedIcon = function (visible) {
    if (this.view) {
        this.view.updateFeedIcon(visible);
    }
};

Feedable.prototype.destructor = function () {
    clearTimeout(this.timeout);
    this.timeout = undefined;
};

Feedable.prototype.handleRemove = function () {
    Feedable.processFeedable();
};

Feedable.Clear = function () {
    clearTimeout(this.processTimeout);
    this.processTimeout = undefined;
};

Feedable.processFeedable = function () {
    if (this.processTimeout) {
        return;
    }

    const game = Map2dLocation.currentLocation;
    if (!game) {
        cleverapps.throwAsync("feed process after game stop");
        return;
    }

    this.processTimeout = setTimeout(() => {
        delete this.processTimeout;
        const foods = [];
        let feedables = [];
        const foodCodeCounter = {};

        game.map.listAvailableUnits((unit) => {
            if (unit.getData().feedableTarget) {
                foods.push(unit);
                foodCodeCounter[unit.code] = (foodCodeCounter[unit.code] || 0) + 1;
            }

            const feedable = unit.findComponent(Feedable);
            if (feedable) {
                feedables.push(feedable);
            }
        });

        const findMinDist = function (feedable) {
            let minDist = 99999;
            foods.forEach((food) => {
                if (Unit.Equals(feedable.food, food)) {
                    const dist = cc.pDistanceSQ(feedable.unit, food);
                    minDist = dist < minDist ? dist : minDist;
                }
            });
            return minDist;
        };

        feedables = feedables.sort((a, b) => {
            const timeDiff = (a.feedTime || 0) - (b.feedTime || 0);
            return timeDiff || (findMinDist(a) - findMinDist(b));
        });

        const isRequiredFood = {};
        for (let i = 0; i < feedables.length; i++) {
            const feedable = feedables[i];
            if (foodCodeCounter[feedable.food.code] && feedable.isAcceptable(foods[0]) && !feedable.eating) {
                if (feedable.isReady()) {
                    foodCodeCounter[feedable.food.code]--;
                    if (!isRequiredFood[feedable.food.code]) {
                        isRequiredFood[feedable.food.code] = true;
                    }
                    feedable.setState(Feedable.STATE_HUNGRY);
                } else {
                    feedable.updateTimer();
                }
            } else if (foods.length === 0 && feedable.canStarve) {
                feedable.setState(Feedable.STATE_BEFORE_STARVE);
                game.counter.setTimeout(() => {
                    if (feedable.state === Feedable.STATE_BEFORE_STARVE) {
                        feedable.setState(Feedable.STATE_STARVE);
                    }
                }, Feedable.BEFORE_STARVE_TIME);
            } else {
                feedable.setState(Feedable.STATE_FULL);
            }
        }

        foods.forEach((food) => {
            const collectible = food.findComponent(Collectible);
            if (collectible) {
                collectible.setFeedables(feedables);
            }

            const pulsing = food.findComponent(Pulsing);
            if (pulsing) {
                pulsing.setActive(isRequiredFood[food.code]);
            }
        });
    }, 100);
};

Feedable.FOOD_FLY_TIME = 650;
Feedable.BEFORE_STARVE_TIME = 1200;
Feedable.FEED_COOLDOWN = cleverapps.parseInterval("10 seconds");

Feedable.STATE_HUNGRY = 0;
Feedable.STATE_FULL = 1;
Feedable.STATE_STARVE = 2;
Feedable.STATE_BEFORE_STARVE = 3;